import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Extend Window interface to include dataLayer
declare global {
  interface Window {
    dataLayer: any[];
  }
}

/**
 * Hook to set up Google Tag Manager tracking
 * - Tracks page views automatically
 */
export const useGTMAnalytics = () => {
  const location = useLocation();

  // Track page views on route change
  useEffect(() => {
    // Simple page view tracking - GTM will handle the rest
    if (window.dataLayer) {
      window.dataLayer.push({
        event: 'pageview',
        page: location.pathname || "/",
      });
    }
  }, [location.pathname]);
};
